import { render, staticRenderFns } from "./EdicaoEmMassa.vue?vue&type=template&id=387942d0"
import script from "./EdicaoEmMassa.vue?vue&type=script&lang=js"
export * from "./EdicaoEmMassa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports